import React from 'react';
import ReactDOM from 'react-dom';
import App from './App.js';
import 'intl';
import 'intl/locale-data/jsonp/cs.js';
import 'intl/locale-data/jsonp/de.js';
import 'intl/locale-data/jsonp/en.js';

ReactDOM.render(<App />, document.getElementById('root'));
